import type * as React from "react";

import type { IconComponentProps } from "../icon-types.ts";

// Google Calendar product mark (2020 geometry): a blue frame with a yellow
// right column, a green bottom row, a folded red corner and "31" on the white
// page. Brand colors are literal on purpose — a mark never takes the theme's
// ink, so `color` and `strokeWidth` are dropped like the Google mark does.
const CALENDAR_BRAND = {
  blue: "#4285F4",
  darkBlue: "#1967D2",
  yellow: "#FBBC04",
  green: "#34A853",
  darkGreen: "#188038",
  red: "#EA4335",
  page: "#FFFFFF",
} as const;

export function GoogleCalendarLogo({
  size = 24,
  ref,
  ...props
}: IconComponentProps): React.ReactElement {
  const { color: _color, strokeWidth: _strokeWidth, ...rest } = props;
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...rest}
    >
      <path fill={CALENDAR_BRAND.page} d="M18.316 5.684H5.684v12.632h12.632z" />
      <path fill={CALENDAR_BRAND.red} d="M18.316 24 24 18.316h-5.684z" />
      <path fill={CALENDAR_BRAND.yellow} d="M24 5.684h-5.684v12.632H24z" />
      <path fill={CALENDAR_BRAND.green} d="M18.316 18.316H5.684V24h12.632z" />
      <path
        fill={CALENDAR_BRAND.darkGreen}
        d="M0 18.316v3.789A1.895 1.895 0 0 0 1.895 24h3.789v-5.684z"
      />
      <path
        fill={CALENDAR_BRAND.darkBlue}
        d="M24 5.684V1.895A1.895 1.895 0 0 0 22.105 0h-3.789v5.684z"
      />
      <path
        fill={CALENDAR_BRAND.blue}
        d="M18.316 0H1.895A1.895 1.895 0 0 0 0 1.895v16.421h5.684V5.684h12.632z"
      />
      <path
        fill={CALENDAR_BRAND.blue}
        d="M8.28 15.53c-.47-.32-.8-.79-.98-1.4l1.1-.45c.1.38.27.67.52.88.24.2.54.3.88.3.35 0 .65-.11.91-.32.25-.21.38-.48.38-.81a1 1 0 0 0-.4-.83c-.27-.21-.6-.31-1-.31h-.64V11.5h.57c.35 0 .64-.1.87-.28.24-.19.36-.44.36-.77a.86.86 0 0 0-.32-.7 1.22 1.22 0 0 0-.8-.26c-.32 0-.57.08-.76.25a1.48 1.48 0 0 0-.41.62l-1.09-.45c.14-.41.41-.77.8-1.08.4-.31.9-.47 1.51-.47.45 0 .86.09 1.22.26.36.18.65.42.85.73.21.31.31.65.31 1.04 0 .39-.1.72-.28.99-.19.27-.42.48-.69.62v.07c.36.15.66.38.89.69.23.31.34.68.34 1.11 0 .43-.11.82-.33 1.16-.22.34-.52.6-.9.8-.39.19-.82.29-1.3.29-.56 0-1.07-.16-1.54-.48ZM14.86 10.1l-1.2.87-.6-.91 2.16-1.56h.83v7.35h-1.19z"
      />
    </svg>
  );
}
